import type { IFiltersParams } from "@app/dashboard/types/innerLayout/home";
import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getMetricCardsData = (metricCardsParams: IFiltersParams) => {
  return axiosPrivate.get(`/dashboard/summary`, { params: { ...metricCardsParams } });
};